const userReducer = (state = {}, action = {}) => {
  let newState = {...state}
  switch (action.type) {
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      return {
        ...newState,
        ...action.result
      }
    case 'CLEAR_NOTIFICATION':
      return {
        ...newState,
        notification_metadata: {
          ...newState.notification_metadata,
          urgent_notifications: [...newState.notification_metadata.urgent_notifications.filter(notification => notification.notification_id != action.notification.notification_id)]
        }
      }
    case 'STORE_ME/NOTIFICATION_DELETE':
      return {
        ...newState,
        notification_metadata: {
          ...newState.notification_metadata,
          urgent_notifications: [...newState.notification_metadata.urgent_notifications.filter(notification => notification.notification_id != action.result.notification_id)]
        }
      }
    case 'STORE_ME/NOTIFICATION_SEARCH_PARTIAL':
      return {...newState, notifications: action.result}
    case 'STORE_ME/NOTIFICATION/METADATA_STREAM':
      if (!_.isEqual(_.omit(action.result,'updated_at'), _.omit(newState.notification_metadata,'updated_at'))) {
        return {
          ...newState,
          notification_metadata: {...action.result}
        }
      } else {
        return state
      }
    default:
      return state
  }
}
  
export default userReducer